<template>
    <div id="toolbar-container" style="height: 27px;" v-bind:style="{'height': '27px', visibility: this.visibility }">
        <link rel="stylesheet" type="text/css" href="https://cdn.bootcss.com/font-awesome/4.6.3/css/font-awesome.min.css" />
        <div class="tab-toolbar tab-fill tab-widget" style="height: 27px; line-height: 27px;">
            <div class="tab-vizItems tab-fill-left horizontal">
                <div class="tabToolbarButton tab-widget" @click="revert()" @mouseenter="handleHover" @mouseleave="handleHover">
                    <i class="fa fa-step-backward" aria-hidden="true"></i>
                    <span class="tabToolbarButtonText"> Revert</span>
                </div>
                <div class="tabToolbarButton tab-widget" @click="refresh()" @mouseenter="handleHover" @mouseleave="handleHover">
                    <i class="fa fa-refresh" aria-hidden="true"></i>
                    <span class="tabToolbarButtonText"> Refresh</span>
                </div>
                <div class="tabToolbarButton tab-widget" @click="pause()" @mouseenter="handleHover" @mouseleave="handleHover">
                    <i :class="this.AutomaticUpdatePaused? 'fa fa-play' : 'fa fa-pause'" aria-hidden="true"></i>
                    <span class="tabToolbarButtonText"> 
                    {{this.AutomaticUpdatePaused? "Resume":"Pause"}}</span>
                </div>
            </div>
            <div class="tab-nonVizItems tab-fill-right horizontal">
                <div class="tabToolbarButton tab-widget" @click="not_impl()" @mouseenter="handleHover" @mouseleave="handleHover">
                    <i class="fa fa-bar-chart" aria-hidden="true"></i>
                    <span class="tabToolbarButtonText">Original View</span></div>
                <div class="tabToolbarButton tab-widget" @click="not_impl()" @mouseenter="handleHover" @mouseleave="handleHover">
                    <i class="fa fa-envelope" aria-hidden="true"></i>
                    <span class="tabToolbarButtonText"> Subscribe</span></div>
                <div class="tabToolbarButton tab-widget" @click="pdf()" @mouseenter="handleHover" @mouseleave="handleHover">
                    <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                    <span class="tabToolbarButtonText"> PDF</span></div>
                <div class="tabToolbarButton tab-widget" @click="data()" @mouseenter="handleHover" @mouseleave="handleHover">
                    <i class="fa fa-link" aria-hidden="true"></i>
                    <span class="tabToolbarButtonText"> Data</span></div>
                <div class="tabToolbarButton tab-widget" @click="crosstab()" @mouseenter="handleHover" @mouseleave="handleHover">
                    <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                    <span class="tabToolbarButtonText"> CrossTab</span></div>
                <div class="tabToolbarButton tab-widget" @click="image()" @mouseenter="handleHover" @mouseleave="handleHover">
                    <i class="fa fa-picture-o" aria-hidden="true"></i>
                    <span class="tabToolbarButtonText"> Image</span></div>
            </div>
        </div>
    </div>

</template>
<style>
    #toolbar-container {
        -webkit-flex: 0 0 auto;
        flex: 0 0 auto;
        position: relative;
        font-family: "Tableau Medium", Tableau, Arial, sans-serif;
    }
    
    .tab-toolbar {
        text-align: center;
        cursor: default;
        overflow: hidden;
        font-size: 11px
    }
    
    .tab-toolbar:lang(ja),
    .tab-toolbar:lang(zh),
    .tab-toolbar:lang(ko) {
        font-size: 12px
    }
    
    .tab-toolbar .tabToolbarButton {
        border: 1px solid #d4d4d4;
        border-top: none;
        border-bottom: none;
        border-color: transparent;
        cursor: pointer;
        color: #000;
        color: rgba(0, 0, 0, .8);
        min-width: 28px;
        display: inline-block;
        vertical-align: top;
        height: 100%;
        white-space: nowrap;
        text-align: left;
        user-select: none;
        -webkit-tap-highlight-color: transparent;
    }
    
    .tab-toolbar .tabToolbarButton > * {
        vertical-align: middle
    }
    
    .tab-toolbar {
        background-color: #fafafa;
        background-color: #fafafa
    }
    
    .public .tab-toolbar {
        background-color: #f6f6f6;
        background-color: rgba(245, 245, 245, .85)
    }
    
    .tab-toolbar .tab-vizItems .tabToolbarButton,
    .tab-toolbar .tab-nonVizItems .tabToolbarButton {
        padding: 0 9px
    }
    
    .tab-toolbar .tab-vizItems.hideLabels .tabToolbarButton,
    .tab-toolbar .tab-nonVizItems.hideLabels .tabToolbarButton {
        padding: 0 4px;
        text-align: center
    }
    
    .tab-toolbar .tab-vizItems .tabToolbarButtonText,
    .tab-toolbar .tab-nonVizItems .tabToolbarButtonText {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        display: inline-block
    }
    
    .tab-toolbar .tabToolbarButtonImg {
        display: block;
        margin: auto
    }
    
    .dj_ie8_docmode_ge8 .tab-toolbar .tabToolbarButtonImg {
        -ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr=#00FFFFFF,endColorstr=#00FFFFFF)"
    }
    
    .tab-toolbar:not(.horizontal) .tabToolbarButton {
        min-width: 44px;
        text-align: center
    }
    
    .tab-toolbar:not(.horizontal) .tabToolbarButton .tabToolbarButtonImg {
        margin-top: 14px;
        margin-bottom: 3px
    }
    
    .tab-toolbar:not(.horizontal) .tabToolbarButton .tabToolbarButtonText {
        line-height: normal
    }
    
    .tab-toolbar .horizontal .tabToolbarButton .tabToolbarButtonImg {
        display: inline-block
    }
    
    .tab-toolbar .horizontal .tabToolbarButton .tabToolbarButtonText {
        padding-left: 6px
    }
    
    .tab-toolbar .hideLabels .tabToolbarButton:before {
        content: "â€Œ"
    }
    
    .tab-toolbar .hideLabels .tabToolbarButton .tabToolbarButtonText {
        display: none
    }
    
    .tab-toolbar .tabToolbarButton.disabled {
        cursor: default;
        opacity: .35;
        filter: alpha(opacity=35);
        zoom: 1
    }
    
    .dj_ie8_docmode_ge8 .tab-toolbar .tabToolbarButton.disabled {
        opacity: .15;
        filter: alpha(opacity=15);
        zoom: 1
    }
    
    .tab-toolbar .tabToolbarButton {
        opacity: .75;
        filter: alpha(opacity=75);
        zoom: 1
    }
    
    .dj_ie8_docmode_ge8 .tab-toolbar .tabToolbarButton {
        opacity: .55;
        filter: alpha(opacity=55);
        zoom: 1
    }
    
    .tab-toolbar .tabToolbarButton.hover {
        opacity: 1;
        filter: alpha(opacity=100);
        zoom: 1
    }
    
    .dj_ie8_docmode_ge8 .tab-toolbar .tabToolbarButton.hover {
        opacity: 1;
        filter: alpha(opacity=100);
        zoom: 1
    }
    
    .tab-toolbar .tabToolbarButton.tabActive {
        background-color: #ababab
    }
    
    .tab-toolbar .tabToolbarButton.tabToolbarButtonFlyoverShown {
        opacity: 1;
        filter: alpha(opacity=100);
        zoom: 1;
        background-color: #fff;
        border-color: #d4d4d4;
        color: #333;
        color: rgba(0, 0, 0, .8);
        z-index: 989;
        position: relative;
        cursor: default
    }
    
    .dj_ie8_docmode_ge8 .tab-toolbar .tabToolbarButton.tabToolbarButtonFlyoverShown {
        opacity: 1;
        filter: alpha(opacity=100);
        zoom: 1
    }
    
    .public .tab-toolbar .tabToolbarButton.tabToolbarButtonFlyoverShown {
        background-color: #333;
        border-color: transparent;
        color: #fff
    }
    
    .tab-toolbar .tab-publicItems {
        padding-top: 10px;
        padding-left: 5px;
        padding-right: 5px;
        position: static;
        display: inline-block
    }
    
    .tab-fill {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0
    }
    
    .tab-fill-left {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0
    }
    
    .tab-fill-right {
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0
    }
    
    .tabUberPopup {
        font-size: 9pt;
        position: absolute;
        z-index: 988;
        cursor: default;
        box-shadow: 1px 2px 1px 0 rgba(0, 0, 0, .1);
        border: 1px solid #d4d4d4;
        background-color: #fff;
        font-family: "Tableau Medium", Tableau, Arial, sans-serif;
    }
    
    .tabUberPopupMinimal.tabUberPopup {
        box-shadow: none;
        border: 0;
        background-color: transparent
    }
    
    .tab-subscriptionView {
        width: 385px;
        padding: 12px
    }
    
    .tab-toolbarFlyout {
        background-color: #fff;
        border: 1px solid #d4d4d4;
        font-size: 12px;
        color: #333;
        color: rgba(0, 0, 0, .8)
    }
    
    .subform {
        display: table;
        border-collapse: separate;
        border-spacing: 8px;
        border-color: grey;
    }
    
    .subform select {
        width: 100%;
        height: 24px;
        line-height: 24px;
    }
    
    .subform select option {
        height: 24px;
        padding: 5px 0;
        font-size: 16px
    }
    
    .subform input {
        width: 100%;
        height: 18px
    }
    
    .subformViewTD {
        width: 180px
    }
    
    .tab-text-button {
        margin-bottom: 6px;
        vertical-align: middle;
        float: right
    }
    
    .tabStyledTextButton {
        cursor: default;
        box-sizing: border-box;
        display: inline-block;
        border: 1px solid transparent;
        border-radius: 1px;
        padding-left: 23px;
        padding-right: 23px;
        height: 23px;
        line-height: 23px;
        font-size: 12px;
        text-align: center
    }
    
    .tabStyledTextButtonFilledGreen {
        border-color: #2dcc97;
        background-color: #2dcc97;
        color: #fff
    }
    
    .tabStyledTextButtonFilledGreen.hover {
        border-color: #2fa37d
    }
    
    .tabStyledTextButtonFilledGreen:active {
        border-color: #2fa37d;
        background-color: #2fa37d
    }
    
    .tab-customViewsView {
        width: 400px;
        padding: 12px
    }
    
    .tab-cv-flyoutSection {
        padding: 6px 0;
        width: 100%
    }
    
    .tab-toolbarFlyoutTitle {
        font-size: 13px;
        margin: 6px 0
    }
    
    .tab-cv-listWrapper {
        max-height: 159.5px;
        overflow-y: auto
    }
    
    .tab-cv-viewListItem {
        height: 23px;
        line-height: 23px;
        padding: 3px 6px;
        max-width: 400px;
        overflow: hidden
    }
    
    .tab-cv-viewListItem i {
        font-size: 14px;
    }
    
    .tab-cv-viewListItem .tab-cv-viewListItem-leftSide {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap
    }
    
    .tab-cv-viewListItem .tab-cv-viewListItem-leftSide i {
        margin-right: 5px;
    }
    
    .tab-cv-viewListItem:hover {
        background-color: #f5f5f5
    }
    
    .tab-cv-viewListItem.tab-cv-viewListItem-currentView {
        background-color: #e6e6e6
    }
    
    .tab-cv-viewListItem .tab-customViews-viewListItem-actionButtonWrapper {
        float: right
    }
    
    .tab-cv-viewListItem .tab-customViews-viewListItem-actionButtonWrapper:before {
        content: " "
    }
    
    .tab-cv-viewListItem .tab-customViews-viewListItem-actionButtonWrapper .tab-iconButton {
        padding-left: 6px;
        padding-right: 6px;
        margin-left: 3px;
        margin-right: 3px
    }
    
    .tab-cv-viewListItem .tab-iconButton {
        display: none
    }
    
    .tab-cv-viewListItem .tab-iconButton.tab-customViews-viewListItem-setDefaultButton {
        display: inline-block;
        visibility: hidden
    }
    
    .tab-customViews-inManageMode .tab-cv-viewListItem .tab-iconButton {
        display: inline-block;
        visibility: visible
    }
    
    .tab-cv-viewListItem.tab-cv-viewListItem-defaultView .tab-customViews-viewListItem-setDefaultButton {
        visibility: visible
    }
    
    .tab-cv-viewListItem.tab-cv-viewListItem-publicView .tab-customViews-viewListItem-toggleHideButton {
        display: inline-block
    }
    
    .tab-cv-viewListItem .tab-iconButton {
        opacity: .75;
        filter: alpha(opacity=75);
        zoom: 1;
        cursor: pointer
    }
    
    .dj_ie8_docmode_ge8 .tab-cv-viewListItem .tab-iconButton {
        opacity: .55;
        filter: alpha(opacity=55);
        zoom: 1
    }
    
    .tab-cv-viewListItem .tab-iconButton.hover {
        opacity: 1;
        filter: alpha(opacity=100);
        zoom: 1
    }
    
    .dj_ie8_docmode_ge8 .tab-cv-viewListItem .tab-iconButton.hover {
        opacity: 1;
        filter: alpha(opacity=100);
        zoom: 1
    }
    
    .tab-cv-viewListItem .tab-iconButton.disabled {
        cursor: default
    }
    
    .tab-customViews-enterManageModeButton {
        padding-left: 0;
        padding-right: 12px
    }
    
    .dj_ie8_docmode_ge8 .tab-customViews-enterManageModeButton .icon {
        -ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr=#00FFFFFF,endColorstr=#00FFFFFF)"
    }
    
    .tab-customViews-saveView {
        display: table
    }
    
    .tab-customViews-saveAreaTitle {
        display: table-cell;
        font-size: 24px;
        padding-bottom: 12px;
        vertical-align: middle
    }
    
    .tab-customViewsView .tab-iconButtonIcon {
        display: inline-block;
        vertical-align: middle
    }
    
    .dj_ie8_docmode_ge8 .tab-customViewsView .tab-iconButtonIcon {
        -ms-filter: "progid:DXImageTransform.Microsoft.gradient(startColorstr=#00FFFFFF,endColorstr=#00FFFFFF)"
    }
    
    .tab-cv-viewListItem-viewName {
        vertical-align: middle
    }
    
    .tab-cv-viewListItem-ownerName {
        font-size: 11px;
        color: #000;
        color: rgba(0, 0, 0, .52);
        font-style: italic;
        float: right;
        max-width: 33%;
        vertical-align: middle;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap
    }
    
    .tab-cv-emptyList {
        height: 65px;
        line-height: 48px;
        text-align: center;
        font-style: italic;
        font-size: 11px;
        color: grey
    }
    
    .tab-customViewsView .tabTextInputViewInputElement {
        box-sizing: border-box;
        font-size: 12px;
        height: 23px;
        padding: 0 3px;
        vertical-align: middle
    }
    
    span.tab-cv-viewNameInputWrapper {
        display: block;
        overflow: hidden;
        padding-bottom: 6px;
        padding-right: 12px
    }
    
    span.tab-cv-viewNameInputWrapper .tabTextInputViewInputElement {
        width: 100%
    }
    
    .tab-customViews-rename-container {
        height: 100%;
        left: 0;
        position: absolute;
        top: 0;
        width: 100%
    }
    
    .tab-customViews-rename-container .tab-cv-viewListItem {
        background-color: transparent;
        position: relative
    }
    
    .tab-customViews-rename-inputWrapper .tabTextInputViewInputElement {
        width: 100%
    }
    
    .tab-customViews-rename-inputWrapper {
        overflow: hidden
    }
    
    .tab-customViews-saveView .tab-text-button {
        margin-bottom: 6px;
        vertical-align: middle;
        float: right
    }
    
    .tab-customViews-saveView .tab-checkbox {
        cursor: default;
        display: inline-block;
        height: 23px;
        margin-bottom: 6px;
        margin-right: 18px
    }
    
    .tab-customViews-saveView .tab-checkbox .label {
        font-size: 11px
    }
    
    .tab-customViews-saveView input[type=checkbox] {
        margin-left: 0
    }
    
    .tab-cv-flyoutSection.tab-cv-manageModeControls {
        text-align: right;
        padding-bottom: 0;
        padding-top: 12px
    }
    
    .tab-cv-flyoutSection + .tab-cv-flyoutSection {
        border-top: 1px solid #e1e1e1
    }
</style>
<script>

export default {
  data(){
      return {
          AutomaticUpdatePaused: false

      }
  },
  props: ["viz", "width", "visibility"],
  mounted: function(){},
  methods: {
    handleHover:function (event) {
    if (event.type == "mouseenter") {
        event.currentTarget.classList.add("hover");
    }
    else {
        event.currentTarget.classList.remove("hover");
    }
    },

    refresh: function() {
        this.viz.refreshDataAsync()
    },
    revert: function(){
        this.viz.revertAllAsync()
    },
    pause: function(){
        this.viz.toggleAutomaticUpdatesAsync()
        this.AutomaticUpdatePaused = ! this.AutomaticUpdatePaused

    },
    not_impl: function(){
    },
    pdf: function(){
        this.viz.showExportPDFDialog()
    },
    data: function(){
        this.viz.showExportDataDialog()
    },
    crosstab: function(){
        this.viz.showExportCrossTabDialog()
    },
    image: function(){
        this.viz.showExportImageDialog()
    }
  }
};

</script>


// WEBPACK FOOTER //
// TableauToolbar.vue?6555ed9f